import {
  AuctionProposalStatus,
  CreditAuctionProposal,
  CreditAuctionProposalListParams,
  CreditAuctionProposalListResponse,
  NegotiationSubStep,
  ResponseAuctionProposalDto,
} from "@/models/credit-auction-proposal.model";
import { CreditEngineReportResponseData } from "@/models/consignado/report-data.model";

const VALIDITY_DEFAULT = "31122026235959";

type ProposalSeed = {
  id: string;
  numeroSolicitacao: number;
  documentoTomador: string;
  nomeTrabalhador: string;
  status: AuctionProposalStatus;
  valorLiberado: number;
  numeroParcelas: number;
  margem: number;
  valorTaxaMensal: number;
  empregador: string;
  cnpj: string;
  dataAdmissao: string;
  dataNascimento: string;
  customStatus?: string | null;
  pep?: boolean;
  negotiationSubStep?: NegotiationSubStep;
  validade?: string;
};

const SEEDS: ProposalSeed[] = [
  {
    id: "mock-001",
    numeroSolicitacao: 100001,
    documentoTomador: "11122233344",
    nomeTrabalhador: "Ana Beatriz Souza",
    status: AuctionProposalStatus.CREATED,
    valorLiberado: 4500,
    numeroParcelas: 12,
    margem: 850,
    valorTaxaMensal: 0.0495,
    empregador: "Tech Solutions LTDA",
    cnpj: "12345678000199",
    dataAdmissao: "2019-02-10",
    dataNascimento: "1990-04-22",
    validade: "07052026073000",
  },
  {
    id: "mock-002",
    numeroSolicitacao: 100002,
    documentoTomador: "22233344455",
    nomeTrabalhador: "Bruno Carvalho Lima",
    status: AuctionProposalStatus.CHOSEN,
    valorLiberado: 12000,
    numeroParcelas: 24,
    margem: 1500,
    valorTaxaMensal: 0.0495,
    empregador: "Construtora Horizonte SA",
    cnpj: "23456789000188",
    dataAdmissao: "2017-08-01",
    dataNascimento: "1985-11-03",
    validade: "07052026233000",
  },
  {
    id: "mock-003",
    numeroSolicitacao: 100003,
    documentoTomador: "33344455566",
    nomeTrabalhador: "Carla Mendes Pereira",
    status: AuctionProposalStatus.IN_AUCTION,
    valorLiberado: 7800,
    numeroParcelas: 18,
    margem: 1100,
    valorTaxaMensal: 0.0495,
    empregador: "Comércio Atlântico ME",
    cnpj: "34567890000177",
    dataAdmissao: "2020-05-12",
    dataNascimento: "1992-07-19",
    customStatus: '[{"data":"2026-04-20T10:00:00Z","status":"CREATED","mensagem":"Proposta criada"},{"data":"2026-04-20T10:05:00Z","status":"IN_AUCTION","mensagem":"Em leilão entre instituições"}]',
    validade: "07052026091500",
  },
  {
    id: "mock-004",
    numeroSolicitacao: 100004,
    documentoTomador: "44455566677",
    nomeTrabalhador: "Daniel Rocha Almeida",
    status: AuctionProposalStatus.PENDING_CONFIRMATION,
    valorLiberado: 15000,
    numeroParcelas: 24,
    margem: 2000,
    valorTaxaMensal: 0.0495,
    empregador: "Indústria Brasileira S.A.",
    cnpj: "45678901000166",
    dataAdmissao: "2015-03-20",
    dataNascimento: "1980-01-15",
    pep: true,
    negotiationSubStep: NegotiationSubStep.PERSONAL_DATA,
    validade: "07052026114500",
  },
  {
    id: "mock-005",
    numeroSolicitacao: 100005,
    documentoTomador: "55566677788",
    nomeTrabalhador: "Eduarda Santos Ribeiro",
    status: AuctionProposalStatus.PENDING_FORMALIZATION,
    valorLiberado: 9200,
    numeroParcelas: 18,
    margem: 1300,
    valorTaxaMensal: 0.0495,
    empregador: "Logística Veloz LTDA",
    cnpj: "56789012000155",
    dataAdmissao: "2021-11-08",
    dataNascimento: "1995-09-30",
    validade: "07052026130000",
  },
  {
    id: "mock-006",
    numeroSolicitacao: 100006,
    documentoTomador: "66677788899",
    nomeTrabalhador: "Felipe Oliveira Costa",
    status: AuctionProposalStatus.PENDING_BANK_ANALYSIS,
    valorLiberado: 22000,
    numeroParcelas: 36,
    margem: 2500,
    valorTaxaMensal: 0.0495,
    empregador: "Banco Nordeste LTDA",
    cnpj: "67890123000144",
    dataAdmissao: "2014-06-15",
    dataNascimento: "1978-12-05",
    validade: "07052026141500",
  },
  {
    id: "mock-007",
    numeroSolicitacao: 100007,
    documentoTomador: "77788899900",
    nomeTrabalhador: "Gabriela Nunes Ferreira",
    status: AuctionProposalStatus.PAYED,
    valorLiberado: 6500,
    numeroParcelas: 12,
    margem: 950,
    valorTaxaMensal: 0.0495,
    empregador: "Padaria Central Ltda",
    cnpj: "78901234000133",
    dataAdmissao: "2022-01-10",
    dataNascimento: "1993-03-25",
    validade: "07052026153000",
  },
  {
    id: "mock-008",
    numeroSolicitacao: 100008,
    documentoTomador: "88899900011",
    nomeTrabalhador: "Henrique Pinto Barros",
    status: AuctionProposalStatus.PAYED,
    valorLiberado: 18000,
    numeroParcelas: 24,
    margem: 2200,
    valorTaxaMensal: 0.0495,
    empregador: "Educação Brasil S.A.",
    cnpj: "89012345000122",
    dataAdmissao: "2016-09-05",
    dataNascimento: "1983-05-18",
    validade: "07052026164500",
  },
  {
    id: "mock-009",
    numeroSolicitacao: 100009,
    documentoTomador: "99900011122",
    nomeTrabalhador: "Isabela Marques Dias",
    status: AuctionProposalStatus.CANCELED,
    valorLiberado: 3000,
    numeroParcelas: 6,
    margem: 600,
    valorTaxaMensal: 0.0495,
    empregador: "Saúde Plus ME",
    cnpj: "90123456000111",
    dataAdmissao: "2023-04-01",
    dataNascimento: "1998-08-12",
    validade: "07052026180000",
  },
  {
    id: "mock-010",
    numeroSolicitacao: 100010,
    documentoTomador: "10011122233",
    nomeTrabalhador: "João Vitor Araújo",
    status: AuctionProposalStatus.CANCELED_BY_CLIENT,
    valorLiberado: 8500,
    numeroParcelas: 18,
    margem: 1200,
    valorTaxaMensal: 0.0495,
    empregador: "Auto Peças Brasil S.A.",
    cnpj: "01234567000100",
    dataAdmissao: "2019-10-22",
    dataNascimento: "1988-02-14",
    validade: "07052026191500",
  },
  {
    id: "mock-011",
    numeroSolicitacao: 100011,
    documentoTomador: "20022233344",
    nomeTrabalhador: "Karina Lopes Teixeira",
    status: AuctionProposalStatus.REPROVED,
    valorLiberado: 11500,
    numeroParcelas: 24,
    margem: 1450,
    valorTaxaMensal: 0.0495,
    empregador: "Comunicações ABC LTDA",
    cnpj: "02345678000189",
    dataAdmissao: "2018-07-19",
    dataNascimento: "1986-10-08",
    validade: "07052026203000",
  },
  {
    id: "mock-012",
    numeroSolicitacao: 100012,
    documentoTomador: "30033344455",
    nomeTrabalhador: "Lucas Fernandes Silva",
    status: AuctionProposalStatus.ERROR_CREATE_BIOMETRIC_VALIDATION,
    valorLiberado: 4200,
    numeroParcelas: 12,
    margem: 700,
    valorTaxaMensal: 0.0495,
    empregador: "Restaurante Sabor & Arte",
    cnpj: "03456789000178",
    dataAdmissao: "2021-02-28",
    dataNascimento: "1991-06-11",
    validade: "07052026214500",
  },
  {
    id: "mock-013",
    numeroSolicitacao: 100013,
    documentoTomador: "40044455566",
    nomeTrabalhador: "Mariana Souza Pereira",
    status: AuctionProposalStatus.REPROVED_IN_PROCESS,
    valorLiberado: 9800,
    numeroParcelas: 18,
    margem: 1320,
    valorTaxaMensal: 0.0495,
    empregador: "Construtora Horizonte LTDA",
    cnpj: "04567890000167",
    dataAdmissao: "2017-11-03",
    dataNascimento: "1985-09-27",
    validade: "07052026220000",
  },
  {
    id: "mock-014",
    numeroSolicitacao: 100014,
    documentoTomador: "50055566677",
    nomeTrabalhador: "Natália Ferreira Lima",
    status: AuctionProposalStatus.PENDING_CONFIRMATION,
    valorLiberado: 7500,
    numeroParcelas: 12,
    margem: 980,
    valorTaxaMensal: 0.0495,
    empregador: "Telecom Brasil S.A.",
    cnpj: "05678901000156",
    dataAdmissao: "2020-08-14",
    dataNascimento: "1991-12-02",
    negotiationSubStep: NegotiationSubStep.WHATSAPP_CONFIRMATION,
    validade: "07052026103000",
  },
  {
    id: "mock-015",
    numeroSolicitacao: 100015,
    documentoTomador: "60066677788",
    nomeTrabalhador: "Otávio Ramos Cardoso",
    status: AuctionProposalStatus.PENDING_CONFIRMATION,
    valorLiberado: 13200,
    numeroParcelas: 24,
    margem: 1700,
    valorTaxaMensal: 0.0495,
    empregador: "Energia Sustentável LTDA",
    cnpj: "06789012000145",
    dataAdmissao: "2016-04-22",
    dataNascimento: "1982-07-30",
    negotiationSubStep: NegotiationSubStep.BANK_DATA,
    validade: "07052026235959",
  },
];

const FIRST_NAMES = [
  "Pedro", "Mariana", "Rafael", "Juliana", "Thiago", "Larissa", "Gustavo",
  "Beatriz", "Vinícius", "Camila", "Rodrigo", "Patrícia", "André", "Letícia",
  "Marcelo", "Fernanda", "Ricardo", "Tatiana", "Eduardo", "Vanessa",
];
const LAST_NAMES = [
  "Almeida", "Cardoso", "Oliveira", "Ribeiro", "Martins", "Cavalcanti",
  "Andrade", "Costa", "Moreira", "Vieira", "Carvalho", "Pinto", "Mendes",
  "Sales", "Borges", "Castro", "Tavares", "Freitas", "Rocha", "Nogueira",
];
const EMPLOYERS = [
  "Indústria Nacional S.A.", "Comércio Atlas LTDA", "Saúde Total ME",
  "Logística Express SA", "Engenharia Sigma LTDA", "Comunicações Beta S.A.",
  "Educação Avante LTDA", "Mineradora Polo SA", "Agro Vale ME",
  "Tecnologia Quark LTDA",
];
const STATUS_POOL: AuctionProposalStatus[] = [
  AuctionProposalStatus.CREATED,
  AuctionProposalStatus.IN_AUCTION,
  AuctionProposalStatus.CHOSEN,
  AuctionProposalStatus.PENDING_BANK_ANALYSIS,
  AuctionProposalStatus.PENDING_CONFIRMATION,
  AuctionProposalStatus.PENDING_FORMALIZATION,
  AuctionProposalStatus.PAYED,
  AuctionProposalStatus.REPROVED,
  AuctionProposalStatus.REPROVED_IN_PROCESS,
];
const SUB_STEPS_POOL: NegotiationSubStep[] = [
  NegotiationSubStep.CPF_INCLUSION,
  NegotiationSubStep.WHATSAPP_CONFIRMATION,
  NegotiationSubStep.SIMULATION,
  NegotiationSubStep.PERSONAL_DATA,
  NegotiationSubStep.ADDRESS,
  NegotiationSubStep.BANK_DATA,
  NegotiationSubStep.ANALISE,
  NegotiationSubStep.PROPOSTA,
  NegotiationSubStep.REVISAO,
  NegotiationSubStep.CONSENTIMENTO,
  NegotiationSubStep.LOCALIZATION,
  NegotiationSubStep.ACEITE_CONTRATACAO,
  NegotiationSubStep.BIOMETRIA,
  NegotiationSubStep.FORMALIZATION,
];

function pad(value: number, length: number): string {
  return String(value).padStart(length, "0");
}

function generateExtraSeeds(count: number, startIndex: number): ProposalSeed[] {
  const extras: ProposalSeed[] = [];
  for (let i = 0; i < count; i++) {
    const idNum = startIndex + i;
    const firstName = FIRST_NAMES[i % FIRST_NAMES.length];
    const lastName = LAST_NAMES[(i * 3) % LAST_NAMES.length];
    const middleName = LAST_NAMES[(i * 7 + 1) % LAST_NAMES.length];
    const status = STATUS_POOL[i % STATUS_POOL.length];
    const isNegotiation = status === AuctionProposalStatus.PENDING_CONFIRMATION;
    const subStep = isNegotiation
      ? SUB_STEPS_POOL[i % SUB_STEPS_POOL.length]
      : undefined;

    const valorLiberado = 2000 + ((i * 137) % 48) * 1000;
    const numeroParcelas = [6, 12, 18, 24, 36][i % 5];
    const margem = 400 + (i % 20) * 100;
    const cpfCore = pad(10000000000 + i * 13, 11);
    const cnpjCore = pad(10000000000000 + i * 17, 14);
    const empregador = EMPLOYERS[i % EMPLOYERS.length];

    const hour = (6 + (i % 17)).toString().padStart(2, "0");
    const minute = ((i * 7) % 60).toString().padStart(2, "0");
    const second = ((i * 11) % 60).toString().padStart(2, "0");
    const validade = `07052026${hour}${minute}${second}`;

    const birthYear = 1970 + (i % 35);
    const birthMonth = pad((i % 12) + 1, 2);
    const birthDay = pad((i % 27) + 1, 2);

    const admissionYear = 2010 + (i % 15);
    const admissionMonth = pad(((i + 3) % 12) + 1, 2);
    const admissionDay = pad(((i + 5) % 27) + 1, 2);

    extras.push({
      id: `mock-${pad(idNum, 3)}`,
      numeroSolicitacao: 100000 + idNum,
      documentoTomador: cpfCore,
      nomeTrabalhador: `${firstName} ${middleName} ${lastName}`,
      status,
      valorLiberado,
      numeroParcelas,
      margem,
      valorTaxaMensal: 0.0495,
      empregador,
      cnpj: cnpjCore,
      dataAdmissao: `${admissionYear}-${admissionMonth}-${admissionDay}`,
      dataNascimento: `${birthYear}-${birthMonth}-${birthDay}`,
      validade,
      ...(subStep ? { negotiationSubStep: subStep } : {}),
    });
  }
  return extras;
}

// Seeds de cobertura: garantem >= 1 proposta para CADA status e CADA substep,
// derivados diretamente dos enums (continua completo se os enums mudarem).
// Ficam no início da lista para aparecerem já na primeira página.
function buildCoverageSeeds(): ProposalSeed[] {
  const baseDefaults = {
    valorLiberado: 5000,
    numeroParcelas: 12,
    margem: 1000,
    valorTaxaMensal: 0.0495,
    empregador: "Cobertura Visual S.A.",
    dataAdmissao: "2020-01-10",
    dataNascimento: "1990-01-15",
    validade: "07052026120000",
  };

  // Um seed por status — exercita todas as Badges de STATUS.
  const statusSeeds: ProposalSeed[] = Object.values(AuctionProposalStatus).map(
    (status, i) => ({
      ...baseDefaults,
      id: `mock-cov-st-${pad(i + 1, 2)}`,
      numeroSolicitacao: 900001 + i,
      documentoTomador: pad(90000000000 + i, 11),
      cnpj: pad(90000000000000 + i, 14),
      nomeTrabalhador: `Cobertura Status ${status}`,
      status,
    }),
  );

  // Um seed por substep, em PENDING_CONFIRMATION (fase "during"), para destacar
  // cada ícone da coluna "Progresso Contratação".
  const subStepSeeds: ProposalSeed[] = Object.values(NegotiationSubStep).map(
    (subStep, i) => ({
      ...baseDefaults,
      id: `mock-cov-ss-${pad(i + 1, 2)}`,
      numeroSolicitacao: 910001 + i,
      documentoTomador: pad(91000000000 + i, 11),
      cnpj: pad(91000000000000 + i, 14),
      nomeTrabalhador: `Cobertura Step ${subStep}`,
      status: AuctionProposalStatus.PENDING_CONFIRMATION,
      negotiationSubStep: subStep,
    }),
  );

  return [...statusSeeds, ...subStepSeeds];
}

SEEDS.unshift(...buildCoverageSeeds());
SEEDS.push(...generateExtraSeeds(85, 100));

const buildResponseDto = (seed: ProposalSeed): ResponseAuctionProposalDto => ({
  id: seed.id,
  shortHash: seed.id.split("-")[1] ?? "0000",
  dataCompetencia: "2026-04-01",
  status: seed.status,
  naturalPersonId: `np-${seed.id}`,
  chosenFinancialInfoId: `cfi-${seed.id}`,
  processorId: null,
  bankDetailId: null,
  unicoDataId: null,
  codigoRequisicao: null,
  statusCustomizado: seed.customStatus ?? null,
  documentoTomador: seed.documentoTomador,
  numeroSolicitacao: seed.numeroSolicitacao,
  margem: seed.margem,
  dataHoraValidadeSolicitacao: seed.validade ?? VALIDITY_DEFAULT,
  valorTaxaMensal: seed.valorTaxaMensal,
  valorLiberado: seed.valorLiberado,
  numeroParcelas: seed.numeroParcelas,
  numeroCcb: null,
  employerId: `emp-${seed.id}`,
  marginId: `mg-${seed.id}`,
  bioGeolocalizacao: null,
  dataDesembolso:
    seed.status === AuctionProposalStatus.PAYED ? "2026-04-25" : null,
  urlComprovantePagamento: null,
  createdAt: "2026-04-15T10:00:00.000Z",
  updatedAt: "2026-04-20T15:30:00.000Z",
  negotiationSubStep: seed.negotiationSubStep ?? null,
});

const computeAge = (birthDate: string): number | null => {
  if (!birthDate) return null;
  const birth = new Date(birthDate);
  if (Number.isNaN(birth.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age -= 1;
  }
  return age;
};

const buildUiProposal = (seed: ProposalSeed): CreditAuctionProposal => ({
  id: seed.id,
  Status: seed.status,
  CustomStatus: seed.customStatus ?? null,
  IdSolicitacao: seed.numeroSolicitacao,
  ShortHash: seed.id.split("-")[1] ?? "0000",
  CreatedAt: "2026-04-15T10:00:00.000Z",
  UrlAutocontratacao: "https://auto.granatech.com.br/contratacao/exemplo-token",
  Cpf: seed.documentoTomador,
  Telefone: `(11) 9${String(seed.numeroSolicitacao).padStart(8, "0")}`,
  Email: `${seed.nomeTrabalhador.toLowerCase().replace(/\s+/g, ".")}@example.com`,
  Idade: computeAge(seed.dataNascimento),
  Sexo: seed.numeroSolicitacao % 2 === 0 ? "Masculino" : "Feminino",
  Matricula: `MAT-${seed.numeroSolicitacao}`,
  InscricaoEmpregador: {
    Codigo: 1,
    Descricao: seed.empregador,
  },
  NumeroInscricaoEmpregador: seed.cnpj,
  ValorLiberado: seed.valorLiberado,
  NroParcelas: seed.numeroParcelas,
  TaxaMensal: seed.valorTaxaMensal,
  Produto: "Crédito Consignado",
  DataDesembolso: seed.status === AuctionProposalStatus.PAYED ? "2026-04-25" : null,
  DataHoraValidadeSolicitacao: VALIDITY_DEFAULT,
  NomeTrabalhador: seed.nomeTrabalhador,
  DataNascimento: seed.dataNascimento,
  MargemDisponivel: seed.margem,
  MargemReal: seed.margem * 3,
  TotalVencimentos: seed.margem * 8,
  ElegivelEmprestimo: seed.status !== AuctionProposalStatus.REPROVED,
  PessoaExpostaPoliticamente: {
    Codigo: seed.pep ? 1 : 0,
    Descricao: seed.pep
      ? "Pessoa Exposta Politicamente"
      : "Pessoa Não Exposta Politicamente",
  },
  DataAdmissao: seed.dataAdmissao,
});

export const MOCK_AUCTION_PROPOSALS_LIST: ResponseAuctionProposalDto[] =
  SEEDS.map(buildResponseDto);

const MOCK_AUCTION_PROPOSALS_DETAILS: Record<string, CreditAuctionProposal> =
  Object.fromEntries(SEEDS.map((seed) => [seed.id, buildUiProposal(seed)]));

export function getMockAuctionProposalsList(
  params: CreditAuctionProposalListParams
): CreditAuctionProposalListResponse {
  let filtered = MOCK_AUCTION_PROPOSALS_LIST;

  if (params.statuses?.length) {
    filtered = filtered.filter((p) => params.statuses!.includes(p.status));
  }

  if (params.searchTerm?.trim()) {
    const term = params.searchTerm.trim().toLowerCase();
    filtered = filtered.filter(
      (p) =>
        p.documentoTomador.toLowerCase().includes(term) ||
        String(p.numeroSolicitacao).includes(term) ||
        p.id.toLowerCase().includes(term)
    );
  }

  if (typeof params.minReleasedValue === "number") {
    filtered = filtered.filter((p) => p.valorLiberado >= params.minReleasedValue!);
  }

  if (typeof params.maxReleasedValue === "number") {
    filtered = filtered.filter((p) => p.valorLiberado <= params.maxReleasedValue!);
  }

  if (params.negotiationSubStep) {
    filtered = filtered.filter(
      (p) => p.negotiationSubStep === params.negotiationSubStep
    );
  }

  if (params.sortBy === "data_validade" && params.sortDirection) {
    const parseValidade = (raw: string | null): number => {
      if (!raw || raw.length !== 14) return Number.POSITIVE_INFINITY;
      const day = raw.slice(0, 2);
      const month = raw.slice(2, 4);
      const year = raw.slice(4, 8);
      const hour = raw.slice(8, 10);
      const min = raw.slice(10, 12);
      const sec = raw.slice(12, 14);
      const time = new Date(
        `${year}-${month}-${day}T${hour}:${min}:${sec}`
      ).getTime();
      return Number.isFinite(time) ? time : Number.POSITIVE_INFINITY;
    };

    const direction = params.sortDirection === "asc" ? 1 : -1;
    filtered = [...filtered].sort(
      (a, b) =>
        direction *
        (parseValidade(a.dataHoraValidadeSolicitacao) -
          parseValidade(b.dataHoraValidadeSolicitacao))
    );
  }

  const total = filtered.length;
  const totalPages = Math.max(1, Math.ceil(total / params.pageSize));
  const currentPage = Math.min(Math.max(1, params.page), totalPages);
  const start = (currentPage - 1) * params.pageSize;
  const data = filtered.slice(start, start + params.pageSize);

  return {
    data,
    total,
    pagina_atual: currentPage,
    tamanho_pagina: params.pageSize,
    total_paginas: totalPages,
    pagina_anterior: currentPage > 1 ? currentPage - 1 : null,
    proxima_pagina: currentPage < totalPages ? currentPage + 1 : null,
  };
}

export function getMockAuctionProposalDetail(
  id: string
): CreditAuctionProposal | null {
  return MOCK_AUCTION_PROPOSALS_DETAILS[id] ?? null;
}

export function getMockAuctionProposalEngineReport(): CreditEngineReportResponseData {
  return {
    proposta: { id: "", status: "", short_hash: "", data_criacao: "" },
    empregador: { nome: "Desconhecido" },
    relatorios: [],
  };
}
